export default "__VITE_ASSET__206fc952__"